import { version } from "../package.json";

export const MINIFY = true;
export const EXTENSION = MINIFY ? ".min.js" : ".js";
export const CDN = "https://nsk-cdn-static.tiendanube.com/";
export const REGISTER_BUNDLE_NAME = `register-${version}`;
export const REGISTER_SRC = `${CDN}${REGISTER_BUNDLE_NAME}${EXTENSION}`;
export const INITIALIZER_BUNDLE_NAME = `initializer-${version}`;
export const INITIALIZER_SRC = `${CDN}${INITIALIZER_BUNDLE_NAME}${EXTENSION}`;
